import { TableSchema } from '../metadata-schema';

export const dim_pc_postcode: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_pc_postcode",
	"description": "Definitie voor dimension tabel dim_pc_postcode uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Landelijk"
	],
	"properties": {
		"pc_nm_plaats": {
			"type": "string",
			"label": "Woonplaats",
			"filter": false,
			"grouping": false,
			"exportable": false
		},
		"pc_nr_pc4": {
			"type": "integer",
			"label": "Postcode",
			"filter": false,
			"grouping": false,
			"exportable": false
		}
	}
};
